import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
});

const reducer = handleActions(
  {
    [types.FORGOT_PASSWORD]: (state) => state.set("isLoading", true),
    [types.FORGOT_PASSWORD_FAIL]: (state) => state.set("isLoading", false),
    [types.FORGOT_PASSWORD_SUCCESS]: (state, { payload: response }) =>
      state
        .set("isLoading", false),
  },
  INITIAL_STATE
);

export default reducer;
